import { render, staticRenderFns } from "./carousel.vue?vue&type=template&id=3e6d50f9&scoped=true&"
import script from "./carousel.vue?vue&type=script&lang=js&"
export * from "./carousel.vue?vue&type=script&lang=js&"
import style0 from "./carousel.vue?vue&type=style&index=0&id=3e6d50f9&prod&scoped=true&lang=css&"
import style1 from "./carousel.vue?vue&type=style&index=1&id=3e6d50f9&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e6d50f9",
  null
  
)

export default component.exports